const estiloData = [
  {
    es: 'Design Thinking y Visual Thinking, incluyendo metodologías Challenge-Led',

    en: 'Design Thinking and Visual Thinking, including Challenge-Led methodologies',
  },

  {
    es: 'El arte de hacerse preguntas',

    en: 'The art of asking questions',
  },

  {
    es: 'Respuestas desde el interior y desde el exterior',

    en: 'Looking for answers both internally and externally',
  },

  {
    es: 'Toma de decisiones en función de datos',

    en: 'Data-driven decision-making',
  },

  {
    es: 'Trabajo colaborativo',

    en: 'Collaborative work',
  },

  {
    es: 'Respeto de los límites personales',

    en: 'Respect for personal boundaries',
  },

  {
    es: 'Llamada a la acción',

    en: 'Call to action',
  },

  {
    es: 'Generación de hojas de ruta',

    en: 'Roadmap development',
  },

  {
    es: 'Uso de indicadores',

    en: 'Use of indicators',
  },

  {
    es: 'Atención a la previsión de riesgos',

    en: 'Risk awareness and anticipation',
  },
];

export default estiloData;